import React from 'react';
import { motion } from 'framer-motion';
export function CtaSection() {
  return <section className="py-24 px-6 bg-navy-900 relative overflow-hidden" data-id="element-11">
      {/* Background Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-accent-teal/10 rounded-full blur-[120px] pointer-events-none" data-id="element-12"></div>

      <div className="max-w-4xl mx-auto text-center relative z-10 bg-navy-800/50 border border-navy-700 backdrop-blur-sm rounded-3xl p-12 md:p-20" data-id="element-13">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-14">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6" data-id="element-15">
            Stop Guessing. Start Knowing.
          </h2>
          <p className="text-xl text-gray-400 mb-10 max-w-2xl mx-auto" data-id="element-16">
            Join the agencies that have turned their fragmented data into their
            greatest competitive advantage. Start your free 14-day trial today.
          </p>
          <button className="bg-accent-teal text-navy-900 hover:bg-accent-teal/90 transition-colors px-8 py-4 rounded-md font-bold text-lg shadow-[0_0_20px_rgba(0,212,170,0.3)]" data-id="element-17">
            Start Your Free Trial
          </button>
          <p className="mt-4 text-xs text-gray-500 font-mono" data-id="element-18">
            No credit card required • Setup in 5 minutes
          </p>
        </motion.div>
      </div>
    </section>;
}